module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/high-roof-window-van-active.ebb3c45e.svg";